import React from "react";
import ReactDOM from "react-dom/client"; // Import from 'react-dom/client'
import App from "./App";
import "./index.css";
import "./style.css";
const container = document.getElementById("root"); // Get the container element
const root = ReactDOM.createRoot(container); // Create a root.

root.render(<App />); // Render the app.

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
